import { useFeatureFlags } from '@usap/core'

const useLoyaltyEnabled = () => {
  const { f98 } = useFeatureFlags()
  if (f98) {
    const flag = String(f98)
    return flag === 'b' || flag === '1' || flag === 'true'
  }
  return false
}

export default useLoyaltyEnabled
